import { getCollectivites, getCollectivite } from '../../../api/collectivite';

import { handleError } from '../../../utils';

export default {
    getCollectivites: ({ commit, dispatch, state }) => {
        if (state.collectivites.length) {
            return state.collectivites;
        }

        return new Promise((resolve) => {
            getCollectivites()
                .then((collectivites) => {
                    commit('setCollectivites', collectivites);
                    resolve(collectivites);
                })
                .catch((error) => handleError(dispatch, error));
        });
    },
    getCollectivite: ({ commit, dispatch }, siteInternetCollectivite) =>
        new Promise((resolve) => {
            getCollectivite(siteInternetCollectivite)
                .then((collectivite) => {
                    if (!collectivite.status) {
                        commit('setCollectivite', collectivite);
                        resolve(collectivite);
                    } else {
                        commit('setCollectivite', null);
                        resolve(collectivite);
                    }
                })
                .catch((error) => handleError(dispatch, error));
        }),
    resetCollectiviteDetail: ({ commit }) => new Promise((resolve) => {
        commit('setCollectivite', null);
        resolve();
    }),
};



// WEBPACK FOOTER //
// ./src/store/modules/Collectivite/actions.js